(() => {
  if (window.mmWholesalePricing) {
    window.mmWholesalePricing();
    return;
  }

  function initialize() {
    const box = document.getElementById('mm-wholesale');
    if (!box || box.dataset.pricingReady === 'true') return;
    const section = box.closest('.shopify-section') || document;
    const config = section.querySelector('[data-mm-wholesale-pricing]');
    if (!config) return;
    box.dataset.pricingReady = 'true';

    const root = config.dataset.root.replace(/\/?$/, '/');
    box.querySelectorAll('a[href^="../"]').forEach((link) => {
      link.setAttribute('href', root + link.getAttribute('href').slice(3));
    });

    const filters = box.querySelector('.mw-filters');
    const cards = Array.from(box.querySelectorAll('.mw-card'));
    const filterNote = box.querySelector('.mw-filter-note');
    const filterNotes = {
      all: config.dataset.filterAll,
      premium: config.dataset.filterPremium,
      latte: config.dataset.filterLatte,
      baking: config.dataset.filterBaking,
    };
    function selectUse(use) {
      if (!Object.prototype.hasOwnProperty.call(filterNotes, use)) return;
      cards.forEach((card) => {
        card.hidden = use !== 'all' && !(card.dataset.group || '').split(' ').includes(use);
      });
      filters?.querySelectorAll('[data-filter]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.filter === use));
      });
      if (filterNote) filterNote.textContent = filterNotes[use];
    }
    if (filters) {
      filters.hidden = false;
      filters.querySelectorAll('[data-filter]').forEach((button) => {
        button.addEventListener('click', () => selectUse(button.dataset.filter));
      });
    }
    box.querySelectorAll('[data-use]').forEach((link) => {
      link.addEventListener('click', () => selectUse(link.dataset.use));
    });

    const calculator = box.querySelector('.mw-calculator');
    const select = box.querySelector('#mw-cost-product');
    const grams = box.querySelector('#mw-cost-grams');
    const value = box.querySelector('#mw-cost-value');
    const yieldText = box.querySelector('#mw-cost-yield');
    const bag = box.querySelector('#mw-cost-bag');
    const costLink = box.querySelector('#mw-cost-link');
    const retry = box.querySelector('.mw-retry');
    if (!calculator || !select || !grams || !value || !yieldText || !bag || !costLink) return;
    if (retry) retry.hidden = true;

    const variants = new Map();
    config.querySelectorAll('template[data-mm-price-variant]').forEach((entry) => {
      variants.set(entry.dataset.mmPriceVariant, entry);
    });
    function calculate() {
      const option = select.options[select.selectedIndex];
      const dose = grams.value;
      const entry = option && variants.get(option.dataset.variant);
      const doseValue = Number(dose);
      value.textContent = '—';
      yieldText.textContent = doseValue > 0
        ? config.dataset.servings.replace('[count]', String(Math.floor(1000 / doseValue)))
        : '';
      if (option) {
        costLink.setAttribute('href', root + 'products/' + encodeURIComponent(option.value) + '?variant=' + encodeURIComponent(option.dataset.variant));
      }
      if (!entry || entry.dataset.mmPriceHandle !== option.value) {
        bag.textContent = config.dataset.priceError;
        return;
      }
      if (entry.dataset.available !== 'true') {
        bag.textContent = config.dataset.soldOut;
        return;
      }
      const price = entry.content.querySelector(`[data-mm-price="${dose}"]`);
      const bagPrice = entry.content.querySelector('[data-mm-price="bag"]');
      if (!price || !bagPrice) {
        bag.textContent = config.dataset.priceError;
        return;
      }
      value.textContent = price.textContent;
      bag.textContent = config.dataset.bagPrice.replace('[price]', bagPrice.textContent);
    }
    select.addEventListener('change', calculate);
    grams.addEventListener('change', calculate);
    calculate();
    calculator.hidden = false;
  }

  window.mmWholesalePricing = initialize;
  document.addEventListener('shopify:section:load', initialize);
  initialize();
})();
